import i18n from '@/i18n';

const PageProperties = () =>
  import(
    /* webpackChunkName: "properties" */ '@/pages/properties/Properties.vue'
  );
const PropertiesFilter = () =>
  import(
    /* webpackChunkName: "properties" */ '@/pages/properties/PropertiesFilter.vue'
  );
const PropertiesTop = () =>
  import(
    /* webpackChunkName: "properties" */ '@/pages/properties/PropertiesTop.vue'
  );

const PageLogbook = () =>
  import(
    /* webpackChunkName: "property" */ '@/pages/property/logbook/Logbook.vue'
  );
const PageProperty = () =>
  import(/* webpackChunkName: "property" */ '@/pages/property/Property.vue');

const PropertyDrawer = () =>
  import(
    /* webpackChunkName: "property" */ '@/pages/property/PropertyDrawer.vue'
  );

const LogbookFilters = () =>
  import(
    /* webpackChunkName: "property" */ '@/pages/property/logbook/LogbookFilters'
  );
const PropertyDetailTable = () =>
  import(/* webpackChunkName: "property" */ '@/pages/FRI/SummaryPropertySheet');
const PropertyDetailsDrawer = () =>
  import(
    /* webpackChunkName: "property" */ '@/pages/property/details/PropertyDetailsDrawer'
  );
const PropertyTop = () =>
  import(/* webpackChunkName: "property" */ '@/pages/property/PropertyTop');

const PropertyDocuments = () =>
  import(
    /* webpackChunkName: "property" */ '@/pages/property/documents/PropertyDocuments'
  );
const PropertyDocumentsDrawer = () =>
  import(
    /* webpackChunkName: "property" */ '@/pages/property/documents/PropertyDocumentsDrawer'
  );

export const LOGBOOKS_ROUTE_NAME = 'properties-logbook';
export const FRI_ROUTE_NAME = 'properties-FRI';
export const PROPERTIES_DOCUMENTS_ROUTE_NAME = 'properties-documents';
export const PROPERTIES_LIST_ROUTE_NAME = 'properties-list';

function getLogbookRoute() {
  return {
    path: 'entries',
    name: LOGBOOKS_ROUTE_NAME,
    components: {
      content: PageLogbook,
      drawer: LogbookFilters,
    },
    props: true,
    meta: {
      title: 'logbook',
      icon: 'location_on',
    },
  };
}

function getPropertyDetailRoute() {
  return {
    path: 'details',
    name: FRI_ROUTE_NAME,
    components: {
      content: PropertyDetailTable,
      drawer: PropertyDetailsDrawer,
    },
    props: true,
    meta: {
      title: 'logbook',
      icon: 'location_on',
    },
  };
}

function getPropertyDocumentsRoute() {
  return {
    path: 'documents',
    name: PROPERTIES_DOCUMENTS_ROUTE_NAME,
    components: {
      content: PropertyDocuments,
      drawer: PropertyDocumentsDrawer,
    },
    props: true,
    meta: {
      title: 'logbook',
      icon: 'location_on',
    },
  };
}

export default {
  getPropertiesRoute() {
    return {
      path: '/properties',
      name: PROPERTIES_LIST_ROUTE_NAME,
      components: {
        top: PropertiesTop,
        default: PageProperties,
        'right-drawer': PropertiesFilter,
      },
      meta: {
        title: 'properties',
        icon: i18n.t('message.properties.icon'),
      },
    };
  },
  getPropertyRoute() {
    return {
      path: 'properties/:propertyId',
      props: true,
      components: {
        default: PageProperty,
        top: PropertyTop,
        'right-drawer': PropertyDrawer,
      },
      meta: {
        isHidden: true,
        title: 'property',
        icon: 'business',
        parent: 'properties',
      },
      children: [
        getPropertyDetailRoute(),
        getLogbookRoute(),
        getPropertyDocumentsRoute(),
      ],
    };
  },
};
